import { render, staticRenderFns } from "./RegisterParticipant.vue?vue&type=template&id=7b79d8f3"
import script from "./RegisterParticipant.vue?vue&type=script&lang=js"
export * from "./RegisterParticipant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports